import { Box, Checkbox, Paper, Typography } from '@mui/material';
import styles from './styles';
import moment from 'moment';

const Line = ({ label, value }) => (
  <Box display="flex" flex={1}>
    <Typography variant="caption" fontWeight="bold" flex={1} textAlign="start">
      {label}:
    </Typography>
    <Typography variant="caption" flex={2} textAlign="start">
      {value || '-'}
    </Typography>
  </Box>
);

const Documentos = ({ itens = [], selected, handleSelect }) =>
  itens?.map((item, idx) => (
    <Box key={idx} display="flex" alignItems="center" mr={2}>
      <Checkbox
        size="small"
        disableRipple
        sx={styles?.checkBox}
        checked={selected?.some((s) => s?.id === item?.id)}
        onChange={() => handleSelect(item)}
      />
      <Paper sx={styles?.paperDoc} elevation={1}>
        <Box display="flex" flexDirection="column" flex={1}>
          <Typography variant="body1" fontWeight="bold" textAlign="start">
            {item?.natureza} {item?.documento || ''}
          </Typography>
          <Line label="Fornecedor" value={item?.fornecedor} />
          <Line
            label="Emissão"
            value={
              Boolean(item?.dtemissao) &&
              moment(item?.dtemissao)?.format('DD/MM/YYYY [às] HH:mm')
            }
          />
        </Box>
      </Paper>
    </Box>
  ));

export default Documentos;
